import * as actionType from '../constants/constant.action'

const defaultState = {}

const resetPasswordReducer = (state = defaultState, action) => {
  switch (action.type) {
    case actionType.GET_ACCESS_CODE_REQUEST:
      return {
        ...state,
        ...action.payload,
        loading: true,
        error: '',
      }

    case actionType.GET_ACCESS_CODE_SUCCESS:
      if (action.payload.response && action.payload.response.status === 500) {
        return {
          ...action.payload,
          serverError: true,
        }
      }
      return {
        ...state,
        ...action.payload,
        loading: false,
      }

    case actionType.GET_ACCESS_CODE_FAILURE:
      return {
        ...state,
        ...action.payload,
        error: action.payload.message,
        loading: false,
      }

    case actionType.GET_FORGET_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
      }

    case actionType.GET_FORGET_PASSWORD_SUCCESS:
      if (action.payload.response && action.payload.response.status === 500) {
        return {
          ...action.payload,
          serverError: true,
        }
      }
      return {
        ...state,
        response: null,
        ...action.payload,
        loading: false,
      }

    case actionType.GET_FORGET_PASSWORD_FAILURE:
      return {
        ...state,
        ...action.payload,
        error: action.payload.message,
        loading: false,
      }

    case actionType.CLEAN_RESET_PASSWORD:
      return defaultState

    default:
      return state
  }
}

export default resetPasswordReducer
